/*
 * BRINDE POR FAIXA DE VALOR
 *
 * Definido pela Estela no review de 01/09: isqueiro a partir de ~R$400 e leque
 * a partir de ~R$700, aparecendo sozinhos na sacola com valor zero — "pra pessoa
 * ver que tem mais um item no carrinho".
 *
 * COMO O BRINDE E RECONHECIDO
 * A linha entra com a propriedade `_brinde`. O underscore no inicio e uma
 * convencao da Shopify: propriedade que comeca com _ nao aparece para a cliente
 * no carrinho nem no e-mail do pedido. E o unico jeito confiavel de separar
 * "isqueiro que ela ganhou" de "isqueiro que ela comprou" — os dois sao o mesmo
 * produto no catalogo, so que o brinde e a versao de R$ 0,00.
 *
 * O QUE CONTA PARA A FAIXA
 * So as pecas compradas. As linhas de brinde sao descontadas do subtotal antes
 * da comparacao — senao um brinde de R$ 0,00 nao muda nada, mas um brinde que
 * um dia tenha preco criaria degrau falso.
 *
 * QUANDO A CLIENTE TIRA O BRINDE NA MAO
 * Nao devolvemos. Ficaria uma queda de braco: ela remove, o site repoe. A recusa
 * fica gravada em sessionStorage e vale ate ela fechar a aba.
 *
 * Desde 30/09 o checkout e o nativo da Shopify (antes era CartPanda), entao a
 * linha de R$ 0,00 garantida aqui e a mesma que chega a tela de pagamento.
 */

(() => {
  const cfg = window.dzBrindes;
  if (!cfg || !cfg.ativo || !cfg.faixas || !cfg.faixas.length) return;

  const CHAVE_RECUSA = 'dz-brinde-recusado';
  let ocupado = false;
  let ultimoEstado = '';

  const recusados = () => {
    try {
      return JSON.parse(sessionStorage.getItem(CHAVE_RECUSA) || '[]');
    } catch {
      return [];
    }
  };

  const recusar = (handle) => {
    try {
      const lista = recusados();
      if (!lista.includes(handle)) {
        lista.push(handle);
        sessionStorage.setItem(CHAVE_RECUSA, JSON.stringify(lista));
      }
    } catch {
      /* navegacao anonima pode bloquear: sem memoria de recusa, e aceitavel */
    }
  };

  const carrinho = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

  /* quais faixas o valor alcanca, respeitando o modo cumulativo */
  const faixasAlcancadas = (centavos) => {
    const batidas = cfg.faixas.filter((f) => f.handle && centavos >= f.minimo * 100);
    if (!batidas.length) return [];
    if (cfg.cumulativo) return batidas;
    return [batidas[batidas.length - 1]]; /* so a mais alta */
  };

  async function conferir() {
    if (ocupado) return;
    ocupado = true;

    try {
      const sacola = await carrinho();
      const linhas = sacola.items || [];

      const brindesNaSacola = linhas.filter((i) => i.properties && i.properties._brinde);
      const subtotal = linhas
        .filter((i) => !(i.properties && i.properties._brinde))
        .reduce((s, i) => s + i.final_line_price, 0);

      const querem = faixasAlcancadas(subtotal).map((f) => f.handle);
      const tem = brindesNaSacola.map((i) => i.properties._brinde);

      /* a cliente tirou um brinde que ela ainda merece? entao ela nao quer */
      querem.forEach((h) => {
        if (!tem.includes(h) && ultimoEstado.includes(h)) recusar(h);
      });

      const sobrando = brindesNaSacola.filter((i) => !querem.includes(i.properties._brinde));
      const faltando = querem.filter((h) => !tem.includes(h) && !recusados().includes(h));

      let mexeu = false;

      /* tira primeiro: se a sacola encolheu, o brinde sai antes de qualquer conta */
      for (const linha of sobrando) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: linha.key, quantity: 0 }),
        });
        mexeu = true;
      }

      for (const handle of faltando) {
        const faixa = cfg.faixas.find((f) => f.handle === handle);
        if (!faixa || !faixa.variante) continue;
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(faixa.variante),
            quantity: 1,
            properties: { _brinde: handle },
          }),
        });
        /* esgotado devolve 422: nao e erro nosso, so nao da para presentear */
        if (resp.ok) mexeu = true;
      }

      ultimoEstado = querem.join('|');
      if (mexeu) document.dispatchEvent(new CustomEvent('dz:brinde-mudou'));
    } catch {
      /* rede caiu no meio: a proxima mexida na sacola tenta de novo */
    } finally {
      ocupado = false;
    }
  }

  /*
   * QUANDO RECONFERIR — e por que nao por evento do tema.
   *
   * Primeira tentativa foi MutationObserver na gaveta. Falhou de um jeito que
   * so aparece testando: o DOM da gaveta muda ANTES de /cart.js refletir a
   * peca nova, entao conferir() lia o carrinho velho, via que nao havia nada a
   * fazer, e nunca mais rodava — nenhuma mutacao nova acontecia depois.
   *
   * A Shopify nao emite evento nativo de carrinho, e o pub/sub do Dawn e um
   * modulo interno (subscribe/PUB_SUB_EVENTS), nao um evento de DOM que de para
   * ouvir daqui. O que TODO mundo faz passa pelo mesmo lugar: uma chamada a
   * /cart/add, /cart/change ou /cart/update. Entao o gatilho e o proprio fetch,
   * depois da resposta — nesse ponto o carrinho ja mudou de verdade.
   */
  const MUTACOES = /\/cart\/(add|change|update|clear)/;
  const fetchOriginal = window.fetch;

  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
    const resposta = fetchOriginal.apply(this, args);
    if (url && MUTACOES.test(url) && !ocupado) {
      resposta
        .then((r) => {
          if (r && r.ok) setTimeout(conferir, 150);
        })
        .catch(() => {});
    }
    return resposta;
  };

  /* formulario sem JS e navegacao normal continuam cobertos */
  ['cart:updated', 'cart:refresh'].forEach((evt) => document.addEventListener(evt, conferir));

  document.addEventListener('DOMContentLoaded', conferir);
  conferir();
})();
